module.exports = __webpack_public_path__ + "img/katarina_events_15.bbef7103.jpg";